import { Mail, ArrowRight } from "lucide-react";
import { Reveal, Overline } from "../components/Reveal";
import { CONTACT_EMAIL } from "../config";

export default function ContactPage() {
    return (
        <main data-testid="contact-page" className="pt-[72px] min-h-screen relative overflow-hidden">
            <div className="absolute top-1/4 left-1/3 w-[36rem] h-[24rem] gold-glow pointer-events-none" />
            <div className="max-w-3xl mx-auto px-6 lg:px-8 py-20 sm:py-28 relative">
                <Reveal>
                    <Overline>Contact</Overline>
                    <h1 className="mt-6 font-serif-display text-4xl sm:text-5xl tracking-tight text-[#FAFAFA]">
                        Get in <span className="italic text-amber-500">touch</span>
                    </h1>
                    <p className="mt-8 text-base leading-relaxed text-zinc-400 max-w-xl">
                        For product questions, press, or partnership enquiries, reach the LookAura team by email. We aim to respond as quickly as possible.
                    </p>
                </Reveal>
                <Reveal delay={0.15}>
                    <a
                        href={`mailto:${CONTACT_EMAIL}`}
                        data-testid="contact-page-email-link"
                        className="group mt-10 inline-flex items-center gap-4 border border-white/10 hover:border-amber-600/50 bg-[#0A0A0A] px-8 py-6 transition-colors duration-300"
                    >
                        <Mail className="w-6 h-6 text-amber-500" strokeWidth={1.5} />
                        <span className="font-serif-display text-xl sm:text-2xl text-[#FAFAFA]">{CONTACT_EMAIL}</span>
                        <ArrowRight className="w-5 h-5 text-zinc-500 transition-transform duration-300 group-hover:translate-x-1" />
                    </a>
                    <p className="mt-5 text-xs font-mono-accent text-zinc-500">
                        Placeholder contact address — replace with the official LookAura email.
                    </p>
                </Reveal>
            </div>
        </main>
    );
}
